import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Admin, User } from '../../../models';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertService } from 'src/app/services/alert.service';

// declare const toastr: any;

@Injectable({ providedIn: 'root' })

export class OrganizationAuthService {

  private organizationAdminUserSubject!: BehaviorSubject<Admin>;
  public organizationAdminUser = new BehaviorSubject({});

  private organizationAdminTokenSubject!: BehaviorSubject<String>;
  private organizationAdminRoleSubject!: BehaviorSubject<String>;
  private organizationAdminPermissionsSubject!: BehaviorSubject<String>;

  constructor(
    private AlertService: AlertService,
    private http: HttpClient) {
    this.organizationAdminTokenSubject = new BehaviorSubject<String>(localStorage.getItem('OrganizationAdminAuthToken') || '');
    this.organizationAdminRoleSubject = new BehaviorSubject<String>(localStorage.getItem('role') || '');
    this.organizationAdminPermissionsSubject = new BehaviorSubject<String>(localStorage.getItem('permissions') || '');
  }

  public get organizationAdminTokenValue(): String {
    return this.organizationAdminTokenSubject.value;
  }

  public get organizationAdminRoleValue(): String {
    return this.organizationAdminRoleSubject.value;
  }

  public get organizationAdminPermissionsValue(): String {
    return this.organizationAdminPermissionsSubject.value;
  }

  public get organizationAdminUserValue(): Admin {
    return this.organizationAdminUserSubject?.value;
  }

  login(userParams: User): Observable<any> {
    return this.http.post<any>(`login/organization`, userParams)
      .pipe(map(userData => {

        localStorage.setItem('OrganizationAdminAuthToken', userData?.record?.token || '');
        localStorage.setItem('role', userData?.record?.user.roles);
        localStorage.setItem('permissions', btoa(btoa(JSON.stringify(userData?.record?.user.permissions))));

        this.organizationAdminTokenSubject.next(userData?.record?.token || null);
        this.organizationAdminRoleSubject.next(userData?.record?.user.roles || null);
        let permissions: any = localStorage.getItem('permissions');
        
        this.organizationAdminPermissionsSubject.next(permissions || null);

        this.organizationAdminUserSubject = new BehaviorSubject<Admin>(userData?.record?.user);
        this.updateUser(userData?.record?.user);

        if (userData?.message) {
          this.AlertService.success(userData.message);
        }

        // toastr.success(userData?.message || 'Login Successfull');

        return userData;
      }));
  }

  logout() {
    return this.http.post(`logout/organization`, {})
      .pipe(map((user: any) => {
        if (user?.message) {
          this.AlertService.success(user.message);
        }
        // toastr.success('Logout Successfully');
        this.navigateToLogin();
        return user;
      }));
  }

  navigateToLogin(message?: string) {
    // this.route.navigate(['/login']);

    localStorage.removeItem('OrganizationAdminAuthToken');
    localStorage.removeItem('role');
    localStorage.removeItem('permissions');

    this.organizationAdminTokenSubject.next('');
    this.organizationAdminRoleSubject.next('');
    this.organizationAdminPermissionsSubject.next('');

    if (message) {
      this.AlertService.error(message);
      // toastr.error(message);
    }

    document.location.href = '/organization/login';
  }

  getPersonalDetails() {
    return this.http.get('organization/admin').pipe(map((res: any) => {
      this.organizationAdminUserSubject = new BehaviorSubject<Admin>(res.record);
      this.updateUser(res.record);
    }));
  }

  updateUser(admin: Admin) {
    this.organizationAdminUser.next(admin);
  }

  forgotPassword(userParams: User): Observable<any> {
    return this.http.post('organization/forgot-password',userParams);
  }

  checkResetPasswordToken(token: any) {
    return this.http.get(`organization/check-token/${token}`);
  }

  resetPassword(data: any) {
    return this.http.post('organization/reset-password',data);  }

}
